/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ParticipantStatus = {
    Active: 'active',
    Revoked: 'revoked',
} as const;
export type ParticipantStatus = typeof ParticipantStatus[keyof typeof ParticipantStatus];


export function instanceOfParticipantStatus(value: any): boolean {
    for (const key in ParticipantStatus) {
        if (Object.prototype.hasOwnProperty.call(ParticipantStatus, key)) {
            if (ParticipantStatus[key as keyof typeof ParticipantStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ParticipantStatusFromJSON(json: any): ParticipantStatus {
    return ParticipantStatusFromJSONTyped(json, false);
}

export function ParticipantStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantStatus {
    return json as ParticipantStatus;
}

export function ParticipantStatusToJSON(value?: ParticipantStatus | null): any {
    return value as any;
}

export function ParticipantStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ParticipantStatus {
    return value as ParticipantStatus;
}

